import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnDestroy, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { InputConverter } from '../../../inputConverter';
import { VideoLogService } from '../../../services/video-log.service';
import { BaseComponent } from '../../base.component';
var VideoLogControllerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VideoLogControllerComponent, _super);
    function VideoLogControllerComponent(_vcf, videoLogService, cdr) {
        var _this = _super.call(this, _vcf, true) || this;
        _this.videoLogService = videoLogService;
        _this.cdr = cdr;
        _this.goToPreviousSegment = _this.videoLogService.goToPreviousSegment.bind(_this.videoLogService);
        _this.goToNextSegment = _this.videoLogService.goToNextSegment.bind(_this.videoLogService);
        _this.goToPreviousCounty = _this.videoLogService.goToPreviousCounty.bind(_this.videoLogService);
        _this.goToNextCounty = _this.videoLogService.goToNextCounty.bind(_this.videoLogService);
        _this.resumeVideo = _this.videoLogService.resumeVideo.bind(_this.videoLogService);
        _this.stopVideo = _this.videoLogService.stopVideo.bind(_this.videoLogService);
        _this.refreshSlider = _this.videoLogService.refreshSlider;
        _this.segmentEnd = _this.videoLogService.segmentEnd;
        _this.countyEnd = _this.videoLogService.countyEnd;
        _this.routeEnd = _this.videoLogService.routeEnd;
        _this.newOffset = _this.videoLogService.newOffset;
        _this.promptSegmentEnd = new EventEmitter();
        _this.promptCountyEnd = new EventEmitter();
        _this.promptSegmentBegin = new EventEmitter();
        _this.promptCountyBegin = new EventEmitter();
        _this.loadHistoricReport = new EventEmitter();
        _this.unsubscribe$ = new Subject();
        _this.hideIntersectionDialogs = true;
        _this.hideDownloadBtn = true;
        _this.allowZoomTypeChange = false;
        _this._toggleImageToggles = false;
        _this.showThreeImages = false;
        _this.topPxBtn = '25px';
        _this.bottomPx = '';
        _this.isPopUp = false;
        _this.showLeftImage = true;
        _this.showCenterImage = true;
        _this.showRightImage = true;
        _this.outsideClickHandler = function () {
            _this.showMenu = false;
        };
        _this.insideClickHandler = function (e) {
            e.stopPropagation();
        };
        _this.toggleButtonsForPopup = function () {
            _this.isPopUp = !_this.isPopUp;
        };
        return _this;
    }
    Object.defineProperty(VideoLogControllerComponent.prototype, "SegmentHighlight", {
        set: function (value) {
            if (this.videoLogService.segHighlightEnabled !== value) {
                this.videoLogService.toggleSegmentHighlight();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogControllerComponent.prototype, "showMenu", {
        get: function () {
            return this._showMenu;
        },
        set: function (value) {
            this._showMenu = value;
            this._showMenu ? this.onShow() : this.onHide();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogControllerComponent.prototype, "toggleImageToggles", {
        get: function () {
            return this._toggleImageToggles;
        },
        set: function (value) {
            this._toggleImageToggles = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogControllerComponent.prototype, "VideoLogService", {
        get: function () {
            return this.videoLogService;
        },
        enumerable: true,
        configurable: true
    });
    VideoLogControllerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.videoLogService.newOffset.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe(function (_) {
            _this.cdr.detectChanges();
        });
        this.videoLogService.newPlayerState.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe(function (_) {
            _this.cdr.detectChanges();
        });
        this.videoLogService.segmentEnd.subscribe(function (position) {
            if (position === 'last') {
                _this.promptSegmentEnd.emit();
            }
            else if (position === 'first') {
                _this.promptSegmentBegin.emit();
            }
        });
        this.videoLogService.countyEnd.subscribe(function (position) {
            if (position === 'last') {
                _this.promptCountyEnd.emit();
            }
            else if (position === 'first') {
                _this.promptCountyBegin.emit();
            }
        });
        this.videoLogService.refreshSlider.subscribe(function (currentYearIndex) {
            if (_this.videoLogService.currentYear) {
                //assigning currentYear to itself to refresh value and fix issues where image's year was not matching slider's year
                _this.videoLogService.currentYear = _this.videoLogService.currentYear;
            }
            else {
                currentYearIndex = currentYearIndex > _this.videoLogService.yearRange.yearIndexMax ? _this.videoLogService.yearRange.yearIndexMax : currentYearIndex;
                _this.videoLogService.currentYear = _this.videoLogService.yearRange.years[currentYearIndex];
            }
            _this.cdr.detectChanges();
        });
        this.videoLogService.panelsSwapped.subscribe(function (showThreeImages) {
            _this.showThreeImages = !showThreeImages;
            _this.topPxBtn = !showThreeImages ? '' : '25px';
            _this.bottomPx = !showThreeImages ? '0px' : '';
        });
        this.videoLogService.imageToggleButtonsReset.subscribe(function () {
            _this.showCenterImage = true;
            _this.showLeftImage = true;
            _this.showRightImage = true;
        });
    };
    VideoLogControllerComponent.prototype.onYearSelect = function (yearIndex) {
        this.videoLogService.currentYear = this.videoLogService.yearRange.years[yearIndex];
        this.loadHistoricReport.emit();
        this.yearSelectorRef.nativeElement.blur();
    };
    VideoLogControllerComponent.prototype.onShow = function () {
        window.addEventListener('mousedown', this.outsideClickHandler);
        window.addEventListener('dragstart', this.outsideClickHandler);
        this.menuToggleRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
        this.menuContainerRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
    };
    VideoLogControllerComponent.prototype.onHide = function () {
        window.removeEventListener('mousedown', this.outsideClickHandler);
        window.removeEventListener('dragstart', this.outsideClickHandler);
        this.menuToggleRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
        this.menuContainerRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
    };
    VideoLogControllerComponent.prototype.toggleLeftImage = function () {
        this.showLeftImage = !this.showLeftImage;
        this.videoLogService.toggleImage('Left');
    };
    VideoLogControllerComponent.prototype.toggleCenterImage = function () {
        this.showCenterImage = !this.showCenterImage;
        this.videoLogService.toggleImage('Center');
    };
    VideoLogControllerComponent.prototype.toggleRightImage = function () {
        this.showRightImage = !this.showRightImage;
        this.videoLogService.toggleImage('Right');
    };
    VideoLogControllerComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    VideoLogControllerComponent.prototype.handleKeyboardEvent = function (event) {
        if (this.videoLogService.keyboardEnabled) {
            if (['Space', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(event.code)) {
                event.stopPropagation();
                event.preventDefault();
            }
            if (event.code === 'Space') {
                this.videoLogService.startOrStopVideo();
            }
            if (event.code === 'ArrowLeft') {
                if (event.shiftKey) {
                    if (this.videoLogService.canGoToFirstOffset) {
                        this.videoLogService.goToFirstOffset();
                    }
                }
                else {
                    if (this.videoLogService.canGoToPreviousOffset) {
                        this.videoLogService.goToPreviousOffset();
                    }
                }
            }
            if (event.code === 'ArrowRight') {
                if (event.shiftKey) {
                    if (this.videoLogService.canGoToLastOffset) {
                        this.videoLogService.goToLastOffset();
                    }
                }
                else {
                    if (this.videoLogService.canGoToNextOffset) {
                        this.videoLogService.goToNextOffset();
                    }
                }
            }
            if (event.code === 'ArrowDown') {
                if (event.shiftKey) {
                    this.videoLogService.playerSpeed = this.videoLogService.playerSetting.maxSpeed;
                }
                else {
                    if (this.videoLogService.playerSpeed + this.videoLogService.playerSetting.step <= this.videoLogService.playerSetting.maxSpeed) {
                        var rounding = 10;
                        this.videoLogService.playerSpeed = Math.round((this.videoLogService.playerSpeed + this.videoLogService.playerSetting.step) * rounding) / rounding;
                    }
                }
            }
            if (event.code === 'ArrowUp') {
                if (event.shiftKey) {
                    this.videoLogService.playerSpeed = this.videoLogService.playerSetting.minSpeed;
                }
                else {
                    if (this.videoLogService.playerSpeed - this.videoLogService.playerSetting.step >= this.videoLogService.playerSetting.minSpeed) {
                        var rounding = 10;
                        this.videoLogService.playerSpeed = Math.round((this.videoLogService.playerSpeed - this.videoLogService.playerSetting.step) * rounding) / rounding;
                    }
                }
            }
        }
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], VideoLogControllerComponent.prototype, "hideIntersectionDialogs", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], VideoLogControllerComponent.prototype, "hideDownloadBtn", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], VideoLogControllerComponent.prototype, "allowZoomTypeChange", void 0);
    return VideoLogControllerComponent;
}(BaseComponent));
export { VideoLogControllerComponent };
